import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../../home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import images
import sport1 from "../../Images/sports/sports-1.webp";
import sport2 from "../../Images/sports/sports-2.webp";
import sport3 from "../../Images/sports/sports-3.webp";
import sport4 from "../../Images/sports/sports-4.webp";
import sport5 from "../../Images/sports/sports-5.webp";
import sport6 from "../../Images/sports/sports-6.webp";
import sport7 from "../../Images/sports/sports-7.webp";
import sport8 from "../../Images/sports/sports-8.webp";
import sport9 from "../../Images/sports/sports-9.webp";
import sport10 from "../../Images/sports/sports-10.webp";
import sport11 from "../../Images/sports/sports-11.webp";
import sport12 from "../../Images/sports/sports-12.webp";

const leftCurveImages = [sport1, sport2, sport3, sport4, sport5, sport6];
const rightCurveImages = [sport7, sport8, sport9, sport10, sport11, sport12];

const Sports = () => {
  const leftSliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    rtl: false,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const rightSliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    rtl: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Settings for right-to-left slider
  // const rightSliderSettings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   vertical: true,
  //   verticalSwiping: true,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   rtl: true,
  // };

  return (
    <section className="sports-curved ptb-50">
      <div className="container-xxl">
        <Row className="">
          <Col lg={5}>
            <div className="sports-content text-start">
              <h2 className="modern-title">
                Where Champions Train – A Hub of{" "}
                <span>Energy and Excellence</span>
              </h2>

              <p className="additional-content">
                ISBM University offers a dynamic sports culture where students
                thrive through discipline, teamwork, and physical excellence.
                From cricket and football to athletics and yoga, we support all
                sports and fitness initiatives.
              </p>

              <p className="additional-content">
                Our state-of-the-art sports facilities include Olympic-standard
                tracks, indoor stadiums, and dedicated coaching staff. Students
                regularly participate in inter-university tournaments and have
                brought numerous accolades to the institution.
              </p>

              {/* <div className="sports-highlights mt-4">
                <Row className="m-0">
                  <Col md={4} className="mb-3">
                    <Card className="sports-card">
                      <Card.Body>
                        <div className="sports-icon">
                          <i className="ti ti-trophy"></i>
                        </div>
                        <Card.Title>Achievements</Card.Title>
                        <Card.Text>
                          50+ National level awards in various sports
                          disciplines
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4} className="mb-3">
                    <Card className="sports-card">
                      <Card.Body>
                        <div className="sports-icon">
                          <i className="ti ti-users"></i>
                        </div>
                        <Card.Title>Facilities</Card.Title>
                        <Card.Text>
                          World-className infrastructure with 15+ sports facilities
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4} className="mb-3">
                    <Card className="sports-card">
                      <Card.Body>
                        <div className="sports-icon">
                          <i className="ti ti-calendar"></i>
                        </div>
                        <Card.Title>Events</Card.Title>
                        <Card.Text>
                          Annual sports fest with 1000+ participants
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div> */}
            </div>
          </Col>
          <Col lg={1}></Col>
          <Col lg={6}>
            <div className="double-curved-container">
              {/* Left curve slider (left-to-right) */}
              <div className="curve-images left-curve">
                <Slider {...leftSliderSettings}>
                  {leftCurveImages.map((img, idx) => (
                    <div key={`left-${idx}`}>
                      <div className="circle-img  mt-3">
                        <img src={img} alt={`Sport ${idx}`} />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>

              {/* Right curve slider (right-to-left) */}
              <div className="curve-images  right-curve">
                <Slider {...rightSliderSettings}>
                  {rightCurveImages.map((img, idx) => (
                    <div key={`right-${idx}`}>
                      <div className="circle-img mt-3">
                        <img src={img} alt={`Sport ${idx}`} />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Sports;
